import { ResourceGroupBase } from '../../resource_group_base'

/**
 * Auction participants.
 *
 * @class
 */
export class Participants extends ResourceGroupBase {
  /**
   * Get participants.
   *
   * @param {object} [query] Request options.
   * @param {Number} [query.page.number] Page number.
   * @param {Number} [query.page.size] Page size.
   * @param {string[]} [query.sort] Sorting params.
   * @return {JsonApiResponse}
   */
  getPage (query) {
    return this
      ._makeCallBuilder()
      .get(query)
  }

  _makeCallBuilder () {
    return this._server
      ._makeCallBuilder()
      .appendUrlSegment('participants')
  }
}
